'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _CountryCell = require('./CountryCell.scss');var _CountryCell2 = _interopRequireDefault(_CountryCell);
var _components = require('../../components');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CountryCell = function CountryCell(props) {var
  tag = props.tag,name = props.name,iso_code = props.iso_code,count = props.count,handleClick = props.handleClick;
  var onClick = function onClick() {return handleClick(tag);};

  return (
    _react2.default.createElement('div', { className: _CountryCell2.default.countriesCell, onClick: onClick },
      _react2.default.createElement('div', { className: _CountryCell2.default.img },
        _react2.default.createElement(_components.FlagIcon, { countryCode: iso_code.toLowerCase() })),

      _react2.default.createElement('div', { className: _CountryCell2.default.title }, name, ' [', count, ']')));


};

CountryCell.propTypes = {
  tag: _propTypes2.default.string,
  name: _propTypes2.default.string,
  iso_code: _propTypes2.default.string,
  count: _propTypes2.default.number,
  handleClick: _propTypes2.default.func };exports.default =


CountryCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CountryCell/CountryCell.js
// module id = 2629
// module chunks = 0